















import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputAutocomplete'
})
export default class InputAutocomplete extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
